<template>
  <div>
    <div class="flex flex-col p-3">
      <div class="pb-3 flex justify-between items-center w-full">
        <el-row class="w-full pb-3" :gutter="10">
          <el-col :span="6" >
            <el-input placeholder="search album name" v-model="filters" @change="searchAlbum" ></el-input>
          </el-col>
          <el-col  :span="6" class="flex items-center">
            <Button @clicked="searchAlbum" label="Apply"/>
            <button class="p-2" ><font-awesome-icon :icon="['fas', 'sync']" @click="resetAlbum" /></button>
          </el-col>
          <el-col :span="12" class="flex justify-end">
            <Button @clicked="isShowModalAdd = true" label="Add Album" variant="outline-primary"/>
          </el-col>
        </el-row>
      </div>
      <el-row class="pb-3 w-full" >
        <el-col :span="24" class="flex flex-row gap-3" >
          <div @click="filterStatus = 0" class="md:w-50 ">
            <div v-bind:class="filterStatus == 0? 'bg-indigo-500 text-gray-100' : ''" class="flex items-center p-4 bg-indigo-200 rounded-lg shadow-xs cursor-pointer hover:bg-indigo-500 hover:text-gray-100">
              <p class="m-auto text-xs font-medium">
                Waiting For Review ({{countWaitingForReviewAlbumArtist}})
              </p>
            </div>
          </div>
          <div @click="filterStatus = 1" class=" md:w-40 ">
            <div v-bind:class="filterStatus == 1? 'bg-indigo-500 text-gray-100' : ''" class="flex items-center p-4 bg-indigo-200 rounded-lg shadow-xs cursor-pointer hover:bg-indigo-500 hover:text-gray-100">
              <p class="m-auto text-xs font-medium">
                Under Review ({{countUnderReviewAlbumArtist}})
              </p>
            </div>
          </div>
          <div @click="filterStatus = 2" class="md:w-40 ">
            <div v-bind:class="filterStatus == 2? 'bg-indigo-500 text-gray-100' : ''" class="flex items-center p-4 bg-indigo-200 rounded-lg shadow-xs cursor-pointer hover:bg-indigo-500 hover:text-gray-100">
              <p class="m-auto text-xs font-medium">
                Approved ({{countApprovedAlbumArtist}})
              </p>
            </div>
          </div>
          <div @click="filterStatus = 3" class="md:w-40 ">
            <div v-bind:class="filterStatus == 3? 'bg-indigo-500 text-gray-100' : ''" class="flex items-center p-4 bg-indigo-200 rounded-lg shadow-xs cursor-pointer hover:bg-indigo-500 hover:text-gray-100">
              <p class="m-auto text-xs font-medium ">
                Rejected ({{countRejectedAlbumArtist}})
              </p>
            </div>
          </div>
          <div @click="filterStatus = 4" class="md:w-40 ">
            <div v-bind:class="filterStatus == 4? 'bg-indigo-500 text-gray-100' : ''" class="flex items-center p-4 bg-indigo-200 rounded-lg shadow-xs cursor-pointer hover:bg-indigo-500 hover:text-gray-100">
              <p class="m-auto text-xs font-medium ">
                Published ({{countPublishedAlbumArtist}})
              </p>
            </div>
          </div>
        </el-col>
      </el-row>
      <data-tables-server ref="tableAlbum" :data="data" :total="total" :pagination-props="{ background: true,pageSizes: [20] }" @query-change="onChangeTable" >
        <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.prop" sortable="custom">
        </el-table-column>
        <el-table-column  label="Publish" class="text-center" >
          <template slot-scope="scope">
            {{ scope.row.published ? 'Published' : 'Not Published' }}
          </template>
        </el-table-column>
        <el-table-column label="Actions" min-width="100px">
          <template slot-scope="scope">
            <div class="static inline-block text-left container-action">
                  <span  class="rounded-md shadow-sm">
                    <div class="py-1" >
                      <VueCustomTooltip label="See Detail" :position="'is-right'">
                        <button class="p-2 mr-2 rounded bg-blue-500 hover:bg-blue-600 focus:outline-none" @click="detail($event,scope.row)">
                          <font-awesome-icon class="text-white" :icon="['fa', 'eye']" />
                        </button>
                      </VueCustomTooltip>
                      <VueCustomTooltip label="Edit" :position="'is-left'">
                        <button  @click="isShowModalEdit = true;idAlbum = scope.row.id" class="p-2 w-8 mr-2 rounded bg-yellow-500 hover:bg-yellow-600 focus:outline-none" >
                          <font-awesome-icon class="text-white" :icon="['fa', 'pencil-alt']" />
                        </button>
                      </VueCustomTooltip>
                    </div>
                  </span>
            </div>
          </template>
        </el-table-column>
      </data-tables-server>
    </div>
    <ModalDialogDetail
      :isShowingModal="isShowingModalDetail"
      :isLoading="isLoading"
      title="Album Details"
      @toggleModal="isShowingModalDetail = !isShowingModalDetail"
      size="xlarge"
    >
      <template slot="body" >
        <DetailAlbum :toggle-reset="isShowingModalDetail" :album-id="idAlbum" ></DetailAlbum>
      </template>
    </ModalDialogDetail>
    <ModalDialog
      ref="addAlbumModal"
      :isShowingModal="isShowModalAdd"
      :label-submit="`Submit`"
      title="Add Album"
      @toggleModal="isShowModalAdd = !isShowModalAdd"
      @save="submit()"
    >
      <template slot="body" >
        <AddAlbum ref="addAlbum" @on-submit-album="onSubmitAlbum" :toggle-reset="isShowModalAdd" :user-id="artistid" :musicverse-cut="musicverseCut" :artist-cut="artistCut"></AddAlbum>
      </template>
    </ModalDialog>
    <ModalDialog
      ref="EditAlbumModal"
      :isShowingModal="isShowModalEdit"
      :label-submit="`Save`"
      title="Edit Album"
      @toggleModal="isShowModalEdit = !isShowModalEdit"
      @save="submitEdit()"
    >
      <template slot="body" >
        <EditAlbum ref="editAlbum" @on-edit-album="onSubmitEditAlbum" :toggle-reset="isShowModalEdit"  :album-id="idAlbum" :musicverse-cut="musicverseCut" :artist-cut="artistCut"></EditAlbum>
      </template>
    </ModalDialog>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { mapActions, mapGetters } from 'vuex';
import VueCustomTooltip from '@adamdehaven/vue-custom-tooltip';
import ModalDialog from '../../components/Common/ModalDialog';
import ModalDialogDetail from '../../components/Common/ModalDialogDetail';
import AddAlbum from '../../views/Album/AddAlbum';
import DetailAlbum from '../../views/Album/DetailAlbum';
import EditAlbum from '../../views/Album/EditAlbum';
import { Button } from '@/components/Layout/Form';

const API_URL = process.env.API_URL;

export default {
  name: 'ListAlbum',
  mixins: [validationMixin],
  props: {
    artistid: {
      type: Number,
    },
    toggleReset: {
      type: Boolean,
    },
    musicverseCut: {
      type: Number,
    },
    artistCut: {
      type: Number,
    },
  },
  data() {
    return {
      isShowingModalDetail: false,
      isShowModalAdd: false,
      isShowModalEdit: false,
      id: null,
      filterStatus: 0,
      filter: {
        page: 1,
        per_page: 20,
        sortby: 'id',
        sortorder: 'asc',
        q: '',
        u: '',
      },
      displayItems: 20,
      data: [],
      total: 0,
      filters: '',
      filterName: '',
      idAlbum: null,
    };
  },
  async mounted() {
    this.id = this.artistid;
  },
  computed: {
    ...mapGetters('NotificationModule', ['isLoading']),
    ...mapGetters('AlbumModule', [
      'listAlbumArtist',
      'listSong',
      'totalSong',
      'countWaitingForReviewAlbumArtist',
      'countUnderReviewAlbumArtist',
      'countApprovedAlbumArtist',
      'countRejectedAlbumArtist',
      'countPublishedAlbumArtist',
    ]),
    titles() {
      return [{
        prop: 'name',
        label: 'Album Name',
      }, {
        prop: 'year',
        label: 'Year',
      }, {
        prop: 'status',
        label: 'Status',
      }];
    },
  },
  watch: {
    artistid: {
      immediate: true,
      async handler(val) {
        // await this.searchMusic();
      },
    },
    listAlbumArtist: {
      immediate: true,
      // eslint-disable-next-line no-unused-vars
      async handler(val) {
        await this.refineData();
      },
    },
    toggleReset: {
      immediate: true,
      // eslint-disable-next-line no-unused-vars
      async handler(val) {
        if (val) {
          this.data = [];
          this.total = 0;
          this.filter = {
            status: 0,
            page: 1,
            per_page: 20,
            sortby: 'id',
            sortorder: 'asc',
            q: '',
            u: '',
          };
          this.filterStatus = 0;
          this.filters = '';
          this.filterName = '';
          await this.searchAlbum();
        }
      },
    },
    filterStatus: {
      immediate: true,
      async handler(newval, oldval) {
        if (typeof (oldval) === 'undefined') return;
        if (newval !== oldval) {
          const data = { id: this.artistid };
          if (newval == 0) {
            const sortby = 'id';
            const sortorder = 'asc';
            this.filter = Object.assign(this.filter, { sortby, sortorder });
          } else {
            const sortby = 'status_updated_at';
            const sortorder = 'desc';
            this.filter = Object.assign(this.filter, { sortby, sortorder });
          }
          const filter = Object.assign(this.filter, { status: newval });
          await this.requestListAlbumByArtist({
            filter, data,
          });
        }
      },
    },
  },
  methods: {
    ...mapActions('AlbumModule', [
      'requestListAlbumByArtist',
    ]),
    async refineData() {
      if (this.listAlbumArtist.length !== 0) {
        this.total = this.listAlbumArtist.total;
        if (typeof (this.listAlbumArtist.data) === 'undefined') return;
        this.data = await Promise.all(this.listAlbumArtist.data.map(async (album) => {
          let status = '';
          switch (album.status) {
            case 1:
              status = 'Under Review';
              break;
            case 2:
              status = 'Approved';
              break;
            case 3:
              status = 'Rejected';
              break;
            case 4:
              status = 'Published';
              break;
            // eslint-disable-next-line no-fallthrough
            case 0:
            default:
              status = 'Waiting for Review';
              break;
          }
          return Object.assign(
            {},
            album,
            {
              status,
              statusCode: album.status,
            },
          );
        }));
      }
    },
    async searchAlbum() {
      const data = { id: this.artistid };
      const filter = Object.assign(this.filter, { q: this.filters, u: this.filterName });
      await this.requestListAlbumByArtist({
        filter, data,
      });
    },
    async resetAlbum() {
      this.$refs.tableAlbum.$refs.elTable.clearSort();
      this.filters = '';
      await this.searchAlbum();
    },
    async onChangeTable(queryInfo) {
      if (queryInfo.type === 'init') return;
      const page = queryInfo.page;
      let sortby = queryInfo.sort.prop;
      let sortorder = queryInfo.sort.order === 'descending' || typeof (queryInfo.sort.order) === 'undefined' ? 'asc' : 'desc';
      if (typeof (sortby) === 'undefined') {
        sortby = 'id';
      }
      if (this.filterStatus == 0) {
        sortby = 'id';
        sortorder = 'asc';
      } else {
        sortby = 'status_updated_at';
        sortorder = 'desc';
      }
      this.filter = Object.assign(this.filter, { sortorder, sortby, page });
      const data = { id: this.artistid };
      await this.requestListAlbumByArtist({
        filter: this.filter, data,
      });
    },
    async detail(event, album) {
      this.idAlbum = album.id;
      this.isShowingModalDetail = !this.isShowingModalDetail;
    },
    async submit() {
      await this.$refs.addAlbum.submit();
    },
    async submitEdit() {
      await this.$refs.editAlbum.submit();
    },
    async onSubmitAlbum(state) {
      this.isShowModalAdd = false;
      await this.searchAlbum();
    },
    async onSubmitEditAlbum(state) {
      this.isShowModalEdit = false;
      await this.searchAlbum();
    },
  },
  components: {
    VueCustomTooltip,
    ModalDialog,
    ModalDialogDetail,
    AddAlbum,
    DetailAlbum,
    EditAlbum,
    Button
  },
};
</script>

<style scoped>
.mx-500{
  max-height: 500px;
}
</style>



// WEBPACK FOOTER //
// src/components/Artist/ListAlbum.vue